import { NotFoundState } from "@rio-cloud/rio-uikit";
import { useMediaQuery } from "@mui/material";

const EmptyTable = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    if (isMobile) {
        return (
            <div className="w-full flex justify-center items-center p-4">
                <NotFoundState
                    headline="Não encontramos nada que corresponda à sua pesquisa"
                    message='Por favor, refine sua pesquisa e tente novamente.'
                    outerClassName="border-none w-full"
                />
            </div>
        );
    }
    return (
        <table className="margin-top-10 w-full">
            <tbody>
                <tr>
                    <td colSpan={5}>
                        <NotFoundState
                            headline="Não encontramos nada que corresponda à sua pesquisa"
                            message='Por favor, refine sua pesquisa e tente novamente.'
                            outerClassName="border-none"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default EmptyTable;